//PORTED FROM ANOTHER PROJECT
var bts = angular.module("mbrweb.larg", []);

require('./services/registration.js')(bts);
require('./services/userService.js')(bts);
require('./directives/btsFooterMessage.js')(bts);




var registrationPage = require('./pages/register')(bts);
 var forgottonPasswordPage = require('./pages/forgot-password')(bts);


bts.run(["runtimeStates", "routes", function (runtimeStates, routes) {

    runtimeStates.state('register', {
        url: '/register{url:(?:.html)?}?campaignId',
        data: {
            appConfigMaintenanceApp: 'REGISTER',
            appConfigMaintenanceKey: 'FULL_MAINTENANCE'
        },
        params: {
            userType: '',
            originalUrl: ''
        },
        views: {
            'body@': {
                template: bootstrap.templates['page-templates/chevronDetail.html'],
                controller: 'pages.register'
            },
            'content@register': {
                //template: require('./pages/register/member-information.html'),
                templateUrl: "register.appTemplate.html/chmhom/larg/pages/register/member-information",
                controller: 'pages.register.memberInformation'
            }
        },
        resolve: {
            registerNotifications: function (contentResourceServices) {
                return contentResourceServices.getResourceIdListAsync("Bluecore Notification");
            },
            chevronContent: function (contentResourceServices) {
                return contentResourceServices.getResourceIdListAsync("Bluecore Navigation");
            },
            isActive: function(sessionData, $window, $q) {
                var deferred = $q.defer();
                var isOldRegistrationActive = (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH &&
                    sessionData.appConfig.SPLASH.OLD_REGISTRATION_ACTIVE) ? sessionData.appConfig.SPLASH.OLD_REGISTRATION_ACTIVE : {};

                if (isOldRegistrationActive && isOldRegistrationActive.booleanValue === true) {

                    //runtimeStates.state.go('pages.ndregistration');
                    deferred.resolve({"redirect": "registration"});
                    //$window.location = "/home/#!/registration/register";

                } else {
                    return true;
                }
            }
        }
    });

    //North dakota registration page
    runtimeStates.state('registration',{
        url:'/registration{url:(?:.html)?}',
        views:{
            'body@': {
                template: bootstrap.templates['page-templates/categoryCustom.html'],
                controller: "pages.ndRegistration"
            },
            "content@registration": {
                templateUrl: 'registration.appTemplate.html/chmhom/larg/pages/ndregistration/memberInformation',
                controller: "pages.ndregistration.memberInformation"
            }
        }

    });

    runtimeStates.state('registration.memberInformation', {
        url: '/register',
        //params: {user: ''},
        views: {
            "content@registration": {
                templateUrl: 'registration.appTemplate.html/chmhom/larg/pages/ndregistration/memberInformation',
                controller: "pages.ndregistration.memberInformation"
            }
    }
    });

    runtimeStates.state('registration.createLogin', {
        url: '/createLogin{url:(?:.html)?}',
        //params: {user: '', identifyResponse: ''},
        views: {
            'content@registration': {
                // template: require('./pages/register/create-login.html'),
                templateUrl: "registration.appTemplate.html/chmhom/larg/pages/ndregistration/createLogin",
                controller: 'pages.ndregistration.createLogin'
            }
        }
    });
    //North dakota registration --end

    runtimeStates.state('register.memberInformation', {
        url: '/member-information{url:(?:.html)?}',
        params: {user: ''},
        views: {}
    });

    runtimeStates.state('register.chip14Confirmation', {
        url: '/chip-14-confirmation{url:(?:.html)?}',
        params: {user: ''},
        views: {
            'content@register': {
                //template: require('./pages/register/chip-14-confirmation.html'),
                templateUrl: "register.appTemplate.html/chmhom/larg/pages/register/chip-14-confirmation",
                controller: 'pages.register.chip14Confirmation'
            }
        },
        resolve: {
            registrationUser: function ($stateParams, $q, $window) {
                var deferred = $q.defer();
                if ($stateParams.user && $stateParams.user.memberId && $stateParams.user.isCHIP === true) {
                    deferred.resolve($stateParams.user);
                } else {
                    deferred.reject();
                    $window.location = "/member/register";
                }
                return deferred.promise;
            }
        }
    });

    runtimeStates.state('register.recoveryInformation', {
        url: '/contact-information{url:(?:.html)?}',
        params: {user: '', identifyResponse: ''},
        views: {
            'content@register': {
                //template: require('./pages/register/recovery-information.html'),
                templateUrl: "register.appTemplate.html/chmhom/larg/pages/register/recovery-information",
                controller: 'pages.register.recoveryInformation'
            }
        },
        resolve: {
            registrationUser: function ($stateParams, $q, $window) {
                var deferred = $q.defer();
                if ($stateParams.user &&
                    $stateParams.user.memberId &&
                    $stateParams.user.hasProfile === true &&
                    $stateParams.identifyResponse &&
                    $stateParams.identifyResponse.returnCode === 200 &&
                    $stateParams.identifyResponse.returnCodeDescription &&
                    $stateParams.identifyResponse.returnCodeDescription.toUpperCase() === 'SUCCESS') {

                    deferred.resolve({user: $stateParams.user, identifyResponse: $stateParams.identifyResponse});
                } else if ($stateParams.user && !$stateParams.user.memberId){
                    deferred.resolve({ user: $stateParams.user });
                } else {
                    deferred.reject();
                    $window.location = "/member/register";
                }
                return deferred.promise;
            }
        }
    });

    runtimeStates.state('register.createLogin', {
        url: '/create-login{url:(?:.html)?}',
        params: {user: '', identifyResponse: ''},
        views: {
            'content@register': {
               // template: require('./pages/register/create-login.html'),
                templateUrl: "register.appTemplate.html/chmhom/larg/pages/register/create-login",
                controller: 'pages.register.createLogin'
            }
        },
        resolve: {
            registrationUser: function ($stateParams, $q, $window) {
                var deferred = $q.defer();
                if ($stateParams.user &&
                    $stateParams.user.memberId &&
                    $stateParams.user.hasProfile === true &&
                    $stateParams.identifyResponse &&
                    $stateParams.identifyResponse.returnCode === 200 &&
                    $stateParams.identifyResponse.returnCodeDescription &&
                    $stateParams.identifyResponse.returnCodeDescription.toUpperCase() === 'SUCCESS') {

                    deferred.resolve({user: $stateParams.user, identifyResponse: $stateParams.identifyResponse});
                } else if($stateParams.user && !$stateParams.user.memberId && $stateParams.identifyResponse ) {
                    deferred.resolve({ user: $stateParams.user, identifyResponse: $stateParams.identifyResponse });
                } else {
                    deferred.reject();
                    $window.location = "/member/register";
                }
                return deferred.promise;
            }
        }
    });

    var doesForgotPasswordExist = false;
    for (var i = 0; i < routes.length; i++) {
        if (routes[i] && routes[i].state === 'forgotPassword') {
            doesForgotPasswordExist = true;
            break;
        }
    }

    if (!doesForgotPasswordExist) {
        // Forgot Password RunTime States
        runtimeStates.state("forgotPassword", {
            url: "/forgot-password{url:(?:.html)?}",
            params: {previousState: '', previousStateParams: {}},
            data: {},
            appConfigMaintenanceApp: 'FORGOT',
            appConfigMaintenanceKey: 'FULL_MAINTENANCE',
            views: {
                'body@': {
                    template: require('./pages/forgot-password.html'),
                    controller: "pages.forgotPassword"
                },
                "content@forgotPassword": {
                    templateUrl: "forgot-password.appTemplate.html/chmhom/larg/pages/forgot-password/step1",
                    controller: "pages.forgotPassword.step1"
                }
            }
        });
    }
    runtimeStates.state('forgotPassword.step1', {
        url: '^/forgot-password/step1{url:(?:.html)?}',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'FORGOT_PASSWORD_STEP1',
        data: {isWCAGCompliant: true},
        params: {error: ''},
        views: {
            "content@forgotPassword": {
                templateUrl: "forgot-password.appTemplate.html/chmhom/larg/pages/forgot-password/step1",
                controller: "pages.forgotPassword.step1"
            }
        }
    });
    runtimeStates.state('forgotPassword.step2', {
        url: '^/forgot-password/step2{url:(?:.html)?}',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'FORGOT_PASSWORD_STEP2',
        data: {isWCAGCompliant: true},
        views: {
            "content@forgotPassword": {
                templateUrl: "forgot-password.appTemplate.html/chmhom/larg/pages/forgot-password/step2",
                controller: "pages.forgotPassword.step2"
            }
        }
    });
    runtimeStates.state('forgotPassword.step3', {
        url: '^/forgot-password/step3{url:(?:.html)?}',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'FORGOT_PASSWORD_STEP3',
        data: {isWCAGCompliant: true},
        views: {
            "content@forgotPassword": {
                templateUrl: "forgot-password.appTemplate.html/chmhom/larg/pages/forgot-password/step3",
                controller: "pages.forgotPassword.step3"
            }
        }
    });
    runtimeStates.state('forgotPassword.recoveryStep2', {
        url: '^/forgot-password/recovery/step2{url:(?:.html)?}',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP2',
        data: {},
        params: {user: ''},
        views: {
            "content@forgotPassword": {
                templateUrl: "forgot-password.appTemplate.html/chmhom/larg/pages/forgot-password/accountRecovery.step2",
                controller: "pages.forgotPassword.accountRecovery.step2"
            }
        }
    });
    runtimeStates.state('forgotPassword.recoveryStep3', {
        url: '^/forgot-password/recovery/step3{url:(?:.html)?}',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP3',
        data: {},
        params: {user: ''},
        views: {
            "content@forgotPassword": {
                templateUrl: "forgot-password.appTemplate.html/chmhom/larg/pages/forgot-password/accountRecovery.step3",
                controller: "pages.forgotPassword.accountRecovery.step3"
            }
        },
        resolve: {
            phoneNumbers: function ($stateParams, userService) {
                if ($stateParams.user) {
                    return userService.getMaskedUserPhone($stateParams.user.userToken, $stateParams.user.userType);
                }
                return false;
            }
        }
    });
    runtimeStates.state('forgotPassword.recoveryStep4', {
        url: '^/forgot-password/recovery/step4{url:(?:.html)?}',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP4',
        data: {},
        params: {user: ''},
        views: {
            "content@forgotPassword": {
                templateUrl: "forgot-password.appTemplate.html/chmhom/larg/pages/forgot-password/accountRecovery.step4",
                controller: "pages.forgotPassword.accountRecovery.step4"
            }
        }
    });
    runtimeStates.state('forgotPassword.recoveryStep4.verify', {
        // Needs converted to use query params instead of path params
        url: '^/forgot-password/recovery/step4/:userToken/:verificationCode',
        appConfigMaintenanceApp: 'FORGOT',
        appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP4',
        data: {},
        params: {user: ''},
        views: {
            "content@forgotPassword": {
                template: '<article></article>',
                controller: "pages.forgotPassword.accountRecovery.step4.verify"
            }
        },
        resolve: {
            verifyCode: function ($stateParams, userService) {
                return userService.verifyCode($stateParams.userToken, $stateParams.verificationCode);
            }
        }
    });
}]);